(function () {
  var DESKTOP = window.matchMedia('(min-width: 750px)');

  function syncGroups(initial) {
    document.querySelectorAll('[data-yf-group]').forEach(function (d) {
      // Desktop exposes every link; mobile starts collapsed (user may then open several).
      if (DESKTOP.matches) d.open = true;
      else if (initial || d.dataset.yfWasDesktop === '1') d.open = false;
      d.dataset.yfWasDesktop = DESKTOP.matches ? '1' : '0';
    });
  }

  // Desktop: summary is not a toggle.
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('.yf__summary');
    if (s && DESKTOP.matches) e.preventDefault();
  });
  document.addEventListener('keydown', function (e) {
    if (!DESKTOP.matches) return;
    var s = e.target.closest && e.target.closest('.yf__summary');
    if (s && (e.key === ' ' || e.key === 'Enter')) e.preventDefault();
  });

  syncGroups(true);
  if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', function () { syncGroups(false); });
  else if (DESKTOP.addListener) DESKTOP.addListener(function () { syncGroups(false); });

  // Cookie preferences: only shown when a real preference interface exists.
  function prefsOpener() {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      return function () { window.privacyBanner.showPreferences(); };
    }
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.showPreferences === 'function') {
      return function () { cp.showPreferences(); };
    }
    return null;
  }

  // The label stays plain text. It only becomes interactive if a real preferences interface exists.
  var labels = document.querySelectorAll('[data-yf-cookie-prefs]');
  function activate(el) {
    var open = prefsOpener();
    if (!open || el.classList.contains('is-live')) return;
    el.classList.add('is-live');
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.addEventListener('click', function () { var o = prefsOpener(); if (o) o(); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); var o = prefsOpener(); if (o) o(); }
    });
  }

  var tries = 0;
  (function reveal() {
    if (prefsOpener()) { labels.forEach(activate); return; }
    if (++tries < 20) setTimeout(reveal, 500);
  })();
})();
